import {
  FaFilePdf,
  FaEdit,
  FaCheckCircle,
  FaTimesCircle,
  FaBan,
  FaLockOpen,
  FaPaperPlane,
} from "react-icons/fa";
import {
  canEditDelete,
  canApprove,
  canReject,
  canCancel,
  isAdmin,
  isLevelOneViewingOtherQuotation,
} from "../utils/buttonVisibility";

const isCustomerSigned = (customerApproval = {}) => {
  const status = String(customerApproval.status || "").toLowerCase();

  return (
    ["accepted", "signed", "customer accepted"].includes(status) ||
    Boolean(
      customerApproval.acceptedAt ||
        customerApproval.signedAt ||
        customerApproval.signatureImageUrl ||
        customerApproval.signedImageUrl
    )
  );
};

const hasAuthorizedSigner = (client = {}) =>
  Array.isArray(client?.authorizedApprovers) &&
  client.authorizedApprovers.some(
    (approver) =>
      String(approver?.name || "").trim() &&
      String(approver?.email || "").trim()
  );

export default function ActionButtons({
  quotation,
  client,
  level,
  email,
  onEdit,
  onDownload,
  onSendToCustomer,
  onUnlock,
  onApprove,
  onReject,
  onCancel,
}) {
  const baseBtn =
    "flex items-center gap-2 px-3 py-1.5 text-sm font-medium rounded-lg border shadow-sm hover:bg-gray-50";
  const isViewOnly = isLevelOneViewingOtherQuotation(quotation);
  const canSendToCustomer =
    !isViewOnly &&
    quotation.approvalStatus === "Approved" &&
    hasAuthorizedSigner(client) &&
    !isCustomerSigned(quotation.customerApproval);

  return (
    <div className="flex flex-wrap justify-end gap-2 mb-6">
      {!isViewOnly && canEditDelete(quotation.approvalStatus) && (
        <button onClick={onEdit} className={`${baseBtn} text-gray-700 bg-white border-gray-300`}>
          <FaEdit size={14} className="text-gray-500" /> Edit
        </button>
      )}

      <button onClick={onDownload} className={`${baseBtn} text-gray-700 bg-white border-gray-300`}>
        <FaFilePdf size={14} className="text-blue-500" />
        Download PDF
      </button>

      {canSendToCustomer && (
        <button
          onClick={onSendToCustomer}
          className={`${baseBtn} text-gray-700 bg-white border-gray-300`}
        >
          <FaPaperPlane size={14} className="text-indigo-500" />
          Send to Customer
        </button>
      )}

      {isAdmin() && quotation.approvalStatus === "Approved" && (
        <button onClick={onUnlock} className={`${baseBtn} text-gray-700 bg-white border-gray-300`}>
          <FaLockOpen size={14} className="text-orange-500" />
          Unlock
        </button>
      )}

      {quotation.approvalHierarchy?.length > 0 && (
        <>
          {canApprove(quotation.approvalStatus, level, quotation.approvalHierarchy) && (
            <button onClick={onApprove} className={`${baseBtn} text-gray-700 bg-white border-gray-300`}>
              <FaCheckCircle size={14} className="text-green-500" />
              Approve
            </button>
          )}

          {canReject(quotation.approvalStatus, level, quotation.approvalHierarchy) && (
            <button onClick={() => onReject("reject")} className={`${baseBtn} text-gray-700 bg-white border-gray-300`}>
              <FaTimesCircle size={14} className="text-red-500" />
              Reject
            </button>
          )}

          {canCancel(quotation.approvalStatus, level, quotation.approvalHierarchy) && (
            <button onClick={() => onCancel("cancel")} className={`${baseBtn} text-gray-700 bg-white border-gray-300`}>
              <FaBan size={14} className="text-gray-500" />
              Cancel
            </button>
          )}
        </>
      )}
    </div>
  );
}